import script from "./CommentsCell.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentsCell.vue?vue&type=script&setup=true&lang=js"

import "./CommentsCell.vue?vue&type=style&index=0&id=45edeede&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45edeede"]])

export default __exports__